export default "__VITE_ASSET__B6GT0SiR__"